// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AllocationRequest } from '@daml.js/splice-api-token-allocation-request/lib/Splice/Api/Token/AllocationRequestV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useAllocationRequests: () => UseQueryResult<
  InterfaceContract<AllocationRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryAllocationRequest', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryAllocationRequestInterface(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useAllocationRequests;
